import { toast } from "sonner";
const API = process.env.REACT_APP_BACKEND_URL;

export default function PlayerAvatar({ name, avatarUrl, size = "md", className = "" }) {
  const sizes = { xs: "w-6 h-6 text-[8px]", sm: "w-8 h-8 text-[10px]", md: "w-10 h-10 text-sm", lg: "w-14 h-14 text-lg", xl: "w-20 h-20 text-2xl" };
  const s = sizes[size] || sizes.md;
  const initial = name?.[0]?.toUpperCase() || "?";
  const fullUrl = avatarUrl ? (avatarUrl.startsWith("http") ? avatarUrl : `${API}${avatarUrl}`) : null;

  return fullUrl ? (
    <img
      src={fullUrl}
      alt={name || "Avatar"}
      className={`${s} rounded-full object-cover border-2 border-background ${className}`}
      onError={(e) => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }}
    />
  ) : (
    <div className={`${s} rounded-full bg-gradient-to-br from-coral/30 to-teal/30 flex items-center justify-center font-bold border-2 border-background ${className}`}>
      {initial}
    </div>
  );
}

export function AvatarUploadButton({ onUploaded }) {
  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) return;
    if (file.size > 5 * 1024 * 1024) return;

    const formData = new FormData();
    formData.append("file", file);

    const token = localStorage.getItem("padel_access_token");
    try {
      const resp = await fetch(`${API}/api/users/avatar`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });
      const data = await resp.json();
      if (!resp.ok) throw new Error(data?.detail || "Upload failed");
      if (onUploaded) onUploaded(data.avatar_url);
    } catch (err) {
      console.error("Avatar upload failed", err);
      toast.error("Could not upload photo");
    }
  };

  return (
    <label
      className="absolute -bottom-1 -right-1 w-7 h-7 rounded-full bg-coral hover:bg-coral-600 flex items-center justify-center cursor-pointer transition-colors border-2 border-background"
      data-testid="avatar-upload-btn"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
      <input type="file" accept="image/*" className="hidden" onChange={handleFile} />
    </label>
  );
}
